<div
  class="gw-flex gw-min-h-0 gw-w-full gw-flex-1 gw-flex-col gw-text-small"
  [class.gw-h-full]="flowActive"
  [attr.data-pix-shell]="pixShellKind"
>
  <form
    [formGroup]="pixTransferForm"
    class="gw-flex gw-min-h-0 gw-flex-col"
    [class.gw-flex-1]="flowActive"
    [class.gw-gap-medium]="!flowActive"
    [class.gw-overflow-hidden]="flowActive"
    [class.gw-gap-0]="flowActive"
    (ngSubmit)="onWizardFormSubmit($event)"
  >
    <div
      [class.gw-flex-1]="flowActive"
      [class.gw-min-h-0]="flowActive"
      [class.gw-overflow-y-auto]="flowActive"
      [class.gw-flex]="flowActive"
      [class.gw-flex-col]="flowActive"
      [class.gw-gap-medium]="flowActive"
      [class.gw-overflow-x-hidden]="flowActive"
    >
      <ng-container [ngSwitch]="recipientStepStatus">
        <app-withdrawal-step-unlocked
          *ngSwitchCase="'unlocked'"
          [form]="pixTransferForm"
          [recipientInputIconName]="recipientInputIconName"
          [recipientMask]="recipientMask"
          [recipientInputType]="recipientInputType"
          [pixKeyCustomMessages]="recipientPixKeyCustomMessages"
          [pixKeyFieldShowsError]="pixKeyFieldShowsError"
          [recipientKindHint]="recipientKindHint"
          [showAmbiguousKindRow]="showAmbiguousKindRow"
          [manualPixKeyKind]="manualPixKeyKind"
          [lookupPending]="pixRecipientLookupPending"
          [lookupErrorMessage]="pixRecipientLookupErrorMessage"
          [bankAccountsLoading]="bankAccountsLoading"
          [contactSearchQuery]="contactSearchQuery"
          [defaultBankAccount]="defaultBankAccount"
          [bankAccounts]="bankAccounts"
          (pixKeyFocus)="onPixKeyFocus()"
          (pixKeyBlur)="onPixKeyBlur()"
          (kindPicked)="pickAmbiguousKind($event)"
          (contactSelected)="selectContact($event)"
        ></app-withdrawal-step-unlocked>

        <app-withdrawal-step-confirmed
          *ngSwitchCase="'confirmed'"
          [pixRecipientResponse]="pixRecipientResponse"
          [resolvedRecipientName]="resolvedRecipientName"
          [confirmedAvatarInitialsSource]="confirmedAvatarInitialsSource"
          [confirmedBankBadgeLetter]="confirmedBankBadgeLetter"
          [confirmedBankDisplayLine]="confirmedBankDisplayLine"
          [hasConfirmedRecipientBankDetails]="hasConfirmedRecipientBankDetails"
          [confirmedPixKeyDisplayMode]="confirmedPixKeyDisplayMode"
          [confirmedPixKeyDigitsForPipe]="confirmedPixKeyDigitsForPipe"
          [confirmedPixKeyLine]="confirmedPixKeyLine"
          [confirmedPixKeyTypeTranslationKey]="
            confirmedPixKeyTypeTranslationKey
          "
          [confirmedPixKeyDisplay]="confirmedPixKeyDisplay"
          (backToSearch)="goBackToRecipientSearchFromConfirmed()"
        ></app-withdrawal-step-confirmed>

        <app-withdrawal-step-value
          *ngSwitchCase="'value'"
          [form]="pixTransferForm"
          [resolvedRecipientName]="resolvedRecipientName"
          [pixAmountCustomMessages]="pixAmountCustomMessages"
          [dailyRemainingHint]="dailyRemainingHint"
          [showHolderDocumentField]="shouldAskHolderDocumentInValueStep"
          [holderDocumentMask]="holderDocumentMask"
          [holderDocumentMaxLength]="holderDocumentMaxLength"
          [holderDocumentCustomMessages]="holderDocumentCustomMessages"
          [amount]="amountBreakdown?.amount ?? null"
          [calculatedFee]="amountBreakdown?.calculatedFee ?? null"
          [finalAmount]="amountBreakdown?.finalAmount ?? null"
          [amountInputMode]="amountInputMode"
          [amountFieldLabelKey]="amountFieldLabelKey"
          [amountFieldHint]="amountFieldHint"
          [amountReadOnly]="emvAmountReadOnly"
          (holderDocumentBlur)="formatHolderDocumentOnBlur()"
          (viewReady)="onValueStepViewReady()"
        ></app-withdrawal-step-value>

        <app-withdrawal-step-review
          *ngSwitchCase="'review'"
          [pixRecipientResponse]="pixRecipientResponse"
          [resolvedRecipientName]="resolvedRecipientName"
          [emvDecoded]="emvDecodedForReview"
          [reviewAmount]="amountBreakdown?.amount ?? null"
          [description]="transferDescriptionForReview"
        ></app-withdrawal-step-review>

        <app-withdrawal-step-payment-proof
          *ngSwitchCase="'payment_proof'"
          [form]="pixTransferForm"
          [confirmedBankDisplayLine]="confirmedBankDisplayLine"
          [resolvedRecipientName]="resolvedRecipientName"
          [isWithdrawalPolling]="isWithdrawalPolling"
          [isWithdrawalSuccess]="isWithdrawalSuccess"
          [isWithdrawalFailed]="showWithdrawalFailureUi"
          [statusErrorMessage]="withdrawalStatusErrorMessage"
          [paymentReceipt]="paymentReceipt"
          [paymentMetadata]="paymentMetadata"
          [amount]="amountBreakdown?.amount ?? null"
          [calculatedFee]="amountBreakdown?.calculatedFee ?? null"
          [finalAmount]="amountBreakdown?.finalAmount ?? null"
        ></app-withdrawal-step-payment-proof>
      </ng-container>
    </div>

    <ng-container *ngIf="flowActive && pixShellKind === 'dialog'">
      <div
        class="gw-h-px gw-w-full gw-bg-border-abnormal gw-mb-medium"
        aria-hidden="true"
      ></div>

      <footer
        class="gw-shrink-0 gw-border-t gw-border-border-normal gw-bg-background-base gw-px-medium gw-pt-medium gw-pb-medium gw-gap-medium"
      >
        <ng-container *ngTemplateOutlet="transferActionFooter"></ng-container>
      </footer>
    </ng-container>

    <ng-template #transferActionFooter>
      <div
        class="gw-h-px gw-w-full gw-bg-border-abnormal gw-mb-medium"
        aria-hidden="true"
      ></div>

      <div class="gw-px-medium">
        <ng-container [ngSwitch]="recipientStepStatus">
          <ng-container *ngSwitchCase="'unlocked'">
            <gatewee-button
              class="gw-w-full"
              [title]="
                'features.withdrawals.modalPix.verifyRecipientContinue'
                  | translate
              "
              [disabled]="!canVerifyRecipient"
              (click)="verifyRecipient()"
            ></gatewee-button>
          </ng-container>

          <ng-container *ngSwitchCase="'confirmed'">
            <gatewee-button
              [title]="
                'features.withdrawals.modalPix.confirmRecipient' | translate
              "
              class="gw-w-full"
              (click)="goToValueStep()"
            ></gatewee-button>
          </ng-container>

          <ng-container *ngSwitchCase="'value'">
            <gatewee-button
              title="{{ 'common.actions.proceed' | translate }}"
              class="gw-w-full"
              [loading]="!valueStepViewReady"
              [disabled]="!valueStepViewReady || !canProceedFromValue"
              (clicked)="goToReviewFromValue()"
            ></gatewee-button>
          </ng-container>

          <ng-container *ngSwitchCase="'review'">
            <div
              *ngIf="transferErrorMessage"
              class="gw-mb-medium gw-rounded-lg gw-border gw-border-status-negative gw-bg-status-negative-pale gw-p-medium gw-text-text-negative gw-text-sm"
              role="alert"
            >
              {{ transferErrorMessage }}
            </div>
            <div
              class="gw-flex gw-items-center gw-justify-between gw-gap-small"
              role="group"
              [attr.aria-label]="
                'features.withdrawals.modalPix.actions.send' | translate
              "
            >
              <div class="gw-flex gw-flex-col">
                <span class="gw-text-text-primary gw-text-lg gw-font-extrabold">
                  {{
                    amountBreakdown?.amount ??
                      pixTransferForm.get('amount')?.value | currency : 'BRL'
                  }}
                </span>
                <span class="gw-text-text-secondary gw-font-normal">
                  {{
                    'features.withdrawals.modalPix.totalAmountLabel' | translate
                  }}
                </span>
              </div>
              <gatewee-button
                title="{{
                  'features.withdrawals.modalPix.actions.send' | translate
                }}"
                [loading]="isSubmitting"
                [disabled]="isSubmitting"
                (click)="onSubmit()"
              ></gatewee-button>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'payment_proof'">
            <div class="gw-mb-[5px]">
              <gatewee-button
                *ngIf="isWithdrawalSuccess && paymentReceipt"
                class="gw-w-full"
                variant="outline"
                iconName="@phi.download-simple"
                [title]="'common.paymentReceipt.export.downloadPng' | translate"
                [loading]="isDownloadingReceipt"
                [disabled]="isDownloadingReceipt"
                (clicked)="downloadReceiptPng()"
              ></gatewee-button>
            </div>
            <div>
              <gatewee-button
                class="gw-w-full"
                [title]="
                  'features.withdrawals.modalPix.proofConclude' | translate
                "
                [disabled]="isWithdrawalPolling"
                (click)="onProofConclude()"
              ></gatewee-button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </form>
</div>
